// extracted by mini-css-extract-plugin
export default {"upperTextShieldRoot":"upperTextShieldRoot___efWvN","s":"s___e63dh","m":"m___nNkqf","l":"l___TxVK6","upperTextShieldImg":"upperTextShieldImg___Peyes"};